export class ContractType {
  contractTypeId: number;
  name: string;

  constructor(contractTypeId: number, name: string) {  
    this.contractTypeId = contractTypeId;
    this.name = name;
  }
}
